<template>
    <div class="field">
        <label class="label">{{ translate("page.tech_account.access_mode") }}:</label>
        <div class="control">
            <Radio class="mr-4" :name="radioName" :initial-value="TECH_ACCOUNT_MODE_FULL_ACCESS" v-model="mode">
                {{ translate("page.tech_account.full_access") }}
            </Radio>
            <Radio :name="radioName" :initial-value="TECH_ACCOUNT_MODE_BUNDLED" v-model="mode">
                {{ translate("page.tech_account.bundled") }}
            </Radio>
        </div>
        <p class="help">{{ translate(helpKey) }}</p>
    </div>

    <div class="field" v-if="mode === TECH_ACCOUNT_MODE_BUNDLED">
        <label class="label">{{ translate("page.tech_account.bundles") }}:</label>
        <div class="control">
            <StaffBundlePicker v-model="bundles" />
        </div>
    </div>
</template>

<script setup lang="ts">
    import StaffBundlePicker from "../Common/StaffBundlePicker.vue";
    import Radio from "../Common/Radio.vue";
    import { translate } from "../Common/translations";
    import { TECH_ACCOUNT_MODE_BUNDLED, TECH_ACCOUNT_MODE_FULL_ACCESS, Bundle, TechAccountMode } from "../Common/consts";

    // Radios of different forms on one page must not share a group.
    withDefaults(defineProps<{ radioName: string; helpKey?: string }>(), {
        helpKey: "page.tech_account.access_mode_help",
    });

    const mode = defineModel<TechAccountMode>("mode", { required: true });
    const bundles = defineModel<Bundle[]>("bundles", { required: true });
</script>
